import Http from '@/utils/http';
import {
    ITextStop,
    IOcrContent,
    ILucaAskDetail,
    ILucaAskProjectSelectInfo,
    IAskChatRecord,
    ILucaAskAllocate,
    IQuestionState,
    IPageParams,
    ISimilarQuestionBySearchItem,
    ICreateRecordsItem,
    ICustomAxiosConfig,
    IFeedbackLabelItem,
    TFeedbackType,
    TResourceType,
    IPageResponse,
    IEveryoneIsAskItemInOcr,
} from '@/types';
import { CancelToken } from 'axios';

/* luca配置信息 */
export const luca_ask_project_select_info = (params: {
    /**
     * lucaId
     */
    lucaId: number;
}) => Http.get<ILucaAskProjectSelectInfo>('/athena/api/v1/front/luca-ask/config/info', params, { needToastError: false });

/* luca答疑详情 */
export const luca_ask_detail = (params: {
    /**
     * 答疑会话Id
     */
    lucaAskChatId: string;
}) => Http.get<ILucaAskDetail>('/athena/api/v1/front/luca-ask/detail', params, { needToastError: false });

/* 创建luca答疑记录 */
export const create_luca_ask_record = (params: any, options?: { timout?: number; cancelToken?: CancelToken }) =>
    Http.post<{ list: IAskChatRecord[] }>('/athena/api/v1/front/luca-ask', params, {
        needToastError: false,
        timeout: Infinity,
        ...(options || {}),
    });

/* 更新luca答疑记录 */
export const update_luca_ask_record = (params: {
    /**
     * 聊天记录id
     */
    recordId: string;
    textStop?: ITextStop;
    ocrContent?: IOcrContent;
}) => Http.put<{ list: IAskChatRecord[] }>('/athena/api/v1/front/luca-ask/askRecord', params, { needToastError: false });

/* 通知后端断开与大模型交互 (超时时使用) */
export const cancel_gpt_reply = (params: {
    /**
     * luca聊天id
     */
    lucaAskChatId?: string;
}) => Http.post('/athena/api/v1/front/chat/chat-no-response', params, { needToastError: false });

/* 停止大模型的回复 (主动停止流) */
export const stop_gpt_reply = (params: {
    /**
     * luca聊天id
     */
    recordId: string;
    /**
     * 文本内容
     */
    textStop: ITextStop;
}) => Http.put<{ list: IAskChatRecord[] }>('/athena/api/v1/front/luca-ask/ask/record', params, { needToastError: false });

/* 问题总结 */
export const luca_ask_problem_summary = (params: {
    /**
     * 答疑会话 ID
     */
    lucaAskChatId: string;
    /**
     * 内容
     */
    content: string;
}) => Http.post<boolean>('/athena/api/v1/front/luca-ask/problem/summary', params, { needToastError: false });

/* 答疑管道分配 */
export const luca_ask_assign = (params: {
    /**
     * lucaId
     */
    lucaId: string;
    /**
     * 项目id
     */
    projectId: number;
    /**
     * 科目id
     */
    subjectId: number;
    /**
     * 二级科目id
     */
    twoLevelSubjectId?: number;
    /**
     * 场景 0-非题目 1-题目
     */
    scenario: 0 | 1;
}) => Http.post<ILucaAskAllocate>('/athena/api/v1/front/luca-ask/allocate', params, { needToastError: false });

/* luca答疑是否解决 */
export const luca_ask_resolved_state = (params: {
    /**
     * 会话 ID
     */
    lucaAskChatId: string;
    /**
     * 状态
     */
    state: IQuestionState;
}) => Http.post<ILucaAskAllocate>('/athena/api/v1/front/luca-ask/resolved/state', params, { needToastError: false });

/* 查询问题总结的botId */
export const luca_ask_problem_summary_config = (params: {
    lucaId: number;
    projectId: number;
    subjectId: number;
    twoLevelSubjectId: number;
}) => Http.get<{ botId: string }>('/athena/api/v1/front/luca-ask/problem/summary/config', params, { needToastError: false });

/* 学科搜索 */
export const luca_ask_similar_problems_search = (
    params: {
        projectId: number;
        subjectId: number;
        question: string;
    } & IPageParams
) =>
    Http.post<{ items: ISimilarQuestionBySearchItem[]; totalHits: number; question: string | null }>(
        '/athena/api/v1/front/luca-ask/similar/problems/search',
        params,
        {
            needToastError: false,
        }
    );

/* 识别图片 */
export const luca_ask_ocr = (params: { imageUrl: string; projectId?: number; subjectId?: number; twoLevelSubjectId?: number }) =>
    Http.post<string>('/athena/api/v1/front/luca-ask/ocr/question-ocr', params, { needToastError: false });

/**
 * luca的会话收藏
 */
export const luca_common_collect = async (params: {
    /**
     * 详情中的主键id
     */
    id?: number;
    /**
     * 详情中的Qa对Id
     */
    qaId?: string;
    /**
     * 知识点切片的记录id
     */
    recordId?: string;
    projectId?: number;
    subjectId?: number;
    twoLevelSubjectId?: number;
    /**
     * 是否收藏
     */
    collectFlag: boolean;
}) => Http.post('/athena/api/v1/front/luca-ask/collect/save', params);

/**
 * 知识切片收藏状态查询
 */
export const knowledge_collect_state = async (params: {
    /**
     * 知识点切片的记录id
     */
    recordId?: string;
}) => Http.get('/athena/api/v1/front/luca-ask/collect/knowledge/state', params);

/**
 * 查询反馈标签列表
 */
export const feedback_label_list = async () => Http.get<IFeedbackLabelItem[]>('/athena/api/v1/front/luca-ask/feedback/label/list', {});

/**
 * 反馈标签提交
 */
export const feedback_sumbit = async (params: {
    lucaAskChatId: string;
    /**
     * 本条记录的id
     */
    lucaAskRecordId: string;
    /**
     * 反馈类型 1 赞 2 踩
     */
    feedbackType?: TFeedbackType;
    /**
     * 标签ID
     */
    labels?: number[];
    /**
     * 反馈内容
     */
    content?: string;
}) => Http.post('/athena/api/v1/front/luca-ask/feedback', params);

/**
 * 校验学员care权限
 */
export const check_care_auth = async (params: { projectId: number; subjectId: number; courseId?: number }) =>
    Http.get('/athena/api/v1/front/luca-ask/check/care/auth', params);

/**
 * 分页大家都在问
 */
export const query_everyone_is_asks = async (
    params: {
        resourceType: TResourceType;
        resourceId: number;
    } & IPageParams,
    options?: ICustomAxiosConfig
) => Http.post<IPageResponse<IEveryoneIsAskItemInOcr>>('/athena/api/v1/front/luca-ask/detail/everyone-asking/pages', params, options);

/**
 * 检测转名师权限
 */
export const check_transform_to_teacher_permission = async (params: { lucaAskChatId: string }) =>
    Http.post<Boolean>('/athena/api/v1/front/luca-ask/check/teacher-ask/permission', params);
